<template>
  <div>
    <v-navigation-drawer
        v-model="drawer"
        :clipped="$vuetify.breakpoint.lgAndUp"
        app
    >
      <v-list dense>
        <template v-for="item in items">
          <v-row
              v-if="item.heading"
              :key="item.heading"
              align="center"
          >
            <v-col cols="6">
              <v-subheader v-if="item.heading">
                {{ item.heading }}
              </v-subheader>
            </v-col>
            <v-col
                cols="6"
                class="text-center"
            >
              <a
                  href="#!"
                  class="body-2 black--text"
              >EDIT</a>
            </v-col>
          </v-row>
          <v-list-group
              v-else-if="item.children"
              :key="item.text"
              v-model="item.model"
              :prepend-icon="item.icon"
              append-icon="">
            <!--              :prepend-icon="item.model ? item.icon : item['icon-alt']"-->
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.text }}
                </v-list-item-title>
              </v-list-item-content>
            </template>
            <span v-for="(child, i) in item.children" :key="i">
              <v-list-item v-if="!isHideChildren(child.text)" link :to="child.to" @click="todo(child.action)"
                           class="ml-10">
                <v-list-item-action v-if="child.icon">
                  <v-icon>{{ child.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ child.text }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </span>
          </v-list-group>
          <v-list-item :key="item.text" link :to="item.to" @click="todo(item.action)" v-if="!item.children &&
          (!item.hidden || name === 'eplang' || name === 'yxs' || name === 'cyx' || name === 'peter') && !isHide(item.text)">
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
        :clipped-left="$vuetify.breakpoint.lgAndUp"
        app
        color="blue darken-3"
        dark
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title
          style="width: 300px"
          class="ml-0 pl-4"
      >
        <span class="hidden-sm-and-down">Amazon Assistant</span>
      </v-toolbar-title>
      <!--<v-text-field
          flat
          solo-inverted
          hide-details
          prepend-inner-icon="mdi-magnify"
          label="Search"
          class="hidden-sm-and-down"
      ></v-text-field>-->
      <v-spacer></v-spacer>
      <v-select id="timer" style="max-width: 250px" hide-details v-model="selectedTimer" :items="timers"
                @change="changeTimer">
        <template v-slot:selection="data">
          <v-list-item-avatar
              style="width:25px; height:25px; min-width: 25px; min-height: 25px; max-width: 25px; max-height: 25px">
            <img alt="国旗" :src="data.item.icon">
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{
                calcTimer(data.item.timeZone)
              }}
            </v-list-item-title>
          </v-list-item-content>
        </template>
        <template v-slot:item="data">
          <v-list-item-avatar>
            <img :src="data.item.icon">
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{ calcTimer(data.item.timeZone) }}</v-list-item-title>
            <v-list-item-subtitle>{{ calcTimeDiff(data.item.text, data.item.timeZone) }}
<!--              UTC: {{ data.item.timeZone }} 时差: {{
                data.item.timeZone - 8
              }}-->
            </v-list-item-subtitle>
          </v-list-item-content>
        </template>
      </v-select>
      <v-btn icon>
        <v-icon>mdi-apps</v-icon>
      </v-btn>
      <v-btn icon>
        <v-icon>mdi-bell</v-icon>
      </v-btn>
      <v-btn icon large>
        <v-avatar size="32px" item>
          <v-img src="https://cdn.vuetifyjs.com/images/logos/logo.svg" alt="Vuetify"></v-img>
          <!--<v-btn icon>
            <v-icon>mdi-account</v-icon>
          </v-btn>-->
        </v-avatar>
      </v-btn>
    </v-app-bar>
    <v-main>
      <router-view :selectedTimer="selectedTimer"></router-view>
    </v-main>
  </div>
</template>

<script>
import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone'
dayjs.extend(utc)
dayjs.extend(timezone)

export default {
  name: "Home",
  props: {
    source: String,
  },
  data: () => ({
    drawer: null,
    name: null,
    items: [
      {
        icon: "mdi-desktop-mac-dashboard",
        text: "Dashboard",
        to: "/home/dashboard"
      },
      {
        icon: "mdi-trending-up",
        text: "今日趋势",
        to: "/home/today"
      },
      {
        icon: "mdi-calendar-today",
        text: "每日汇总",
        to: "/home/diaries"
      },
      {
        icon: "mdi-format-list-bulleted-type",
        text: "历史订单",
        to: "/home/orders"
      },
      {
        icon: "mdi-format-list-text",
        text: "商品列表",
        to: "/home/products"
      },
      {
        icon: "mdi-store",
        text: "店铺管理",
        to: "/home/stores",
        // hidden: true
      },
      {
        icon: "mdi-account-multiple",
        text: "部门管理",
        to: "/home/groups",
        hidden: true
      },
      {
        icon: 'mdi-message-text-clock',
        text: '索评管理',
        to: '/home/request'
      },
      {
        icon: "mdi-file-word-box",
        text: "关键词",
        to: "/home/keyword",
      },
      {
        icon: "mdi-truck",
        text: "物流供应商",
        to: "/home/quotation",
        children: [
          {
            icon: "mdi-ferry",
            text: "渠道管理",
            to: "/home/quotation/provider",
          },
          {
            icon: "mdi-tag",
            text: "报价管理",
            to: "/home/quotation/quotations",
          },
          {
            icon: "mdi-tag-search",
            text: "报价查询",
            to: "/home/quotation/search",
          },
        ]
      },
      {
        icon: "mdi-web",
        text: "官网管理",
        children: [
          {
            icon: "mdi-ferry",
            text: "网页模块",
            to: "/home/website",
          },
          {
            icon: "mdi-tag",
            text: "商品管理",
            to: "/home/quotation/quotations",
          },
        ]
      },
      {
        icon: "mdi-cog", text: "设置"
      },
      {
        icon: "mdi-logout", text: "退出", action: "logout"
      }
    ],
    currentTime: new Date(),
    selectedTimer: null,
    timers: [
      {icon: "icon/flag/cn.png", text: "中国", value: "CN", timeZone: "Asia/Shanghai"},
      {icon: "icon/flag/us.png", text: "美国", value: "US", timeZone: "America/Los_Angeles"},
      {icon: "icon/flag/jp.png", text: "日本", value: "JP", timeZone: "Asia/Tokyo"},
      {icon: "icon/flag/en.png", text: "英国", value: "UK", timeZone: "Europe/London"},
      {icon: "icon/flag/fr.png", text: "法国", value: "FR", timeZone: "Europe/Paris"},
      {icon: "icon/flag/de.png", text: "德国", value: "DE", timeZone: "Europe/Berlin"},
      {icon: "icon/flag/it.png", text: "意大利", value: "IT", timeZone: "Europe/Rome"},
      {icon: "icon/flag/au.png", text: "澳大利亚", value: "AU", timeZone: "Australia/Sydney"},
      {icon: "icon/flag/ca.png", text: "加拿大", value: "CA", timeZone: "America/Vancouver"},
      {icon: "icon/flag/es.png", text: "西班牙", value: "ES", timeZone: "Europe/Madrid"}
    ]
  }),
  methods: {
    isHide(target) {
      if (target !== '退出' && target !== '物流供应商') {
        return this.name === 'hwl' || this.name === 'dsm' || this.name === 'cdh' || this.name === 'lym' || this.name === 'xiaqing' || this.name === 'wangxia' || this.name === 'lwh' || this.name === 'zfl'
      }

      return false
    },
    isHideChildren(target) {
      // let blacked = ['hwl', 'dsm', 'cdh']
      if (target === '渠道管理' || target === '报价管理') {
        return this.name === 'hwl' || this.name === 'dsm' || this.name === 'cdh' || this.name === 'lwh' || this.name === 'zfl'
        /*for (let text in blacked) {
          if (this.name === text) {
            return true
          }
        }*/
      }
      return false
    },
    calcTimer(timeZone) {
      return dayjs(this.currentTime).tz(timeZone).format('MM-DD HH:mm:ss');
    },
    calcTimeDiff(text, timeZone) {
      let date = dayjs(this.currentTime).tz(timeZone);
      let current = dayjs().format("Z")
      let target = date.format("Z")
      let diff = parseFloat(current.substring(0, current.indexOf(":"))) - parseFloat(target.substring(0, target.indexOf(":")))

      return `${text} UTC: ${date.format("Z")} 时差: ${diff}`;
    },
    changeTimer(value) {
      console.log(value);
      localStorage.selectedTimer = value;
    }, todo(action) {
      switch (action) {
        case "logout":
          console.log("用户退出登录");
          localStorage.removeItem("token");
          this.$router.push("/login").catch(() => {
          });
          break;
      }
    }
  }, beforeMount() {
    this.selectedTimer = localStorage.selectedTimer ? localStorage.selectedTimer : "CN";
    this.name = localStorage.name;
    let _this = this;   //声明一个变量指向Vue实例this，保证作用域一致
    this.timer = setInterval(function () {
      _this.currentTime = new Date();    //修改数据date
    }, 1000);
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);  //在Vue实例销毁前，清除定时器
    }
  }
}
</script>

<style>
#timer {
  display: none !important;
}
</style>